import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { callbackLeadCountsQuery } from "@/app/CallbackLeads/GraphQL/callbackLeadCountsQuery";
import { SidebarPulseIndicator } from "@/lib/Components/Layout/Sidebar/SidebarPulseIndicator";
import { useTranslations } from "use-intl";

export function CallbackLeadsNotificationIndicator() {
  const t = useTranslations("callbackLead");
  const { data } = useGqlQuery(callbackLeadCountsQuery, {});

  const count =
    (data?.callbackLeadCounts.pendingIncompleteBooking ?? 0) +
    (data?.callbackLeadCounts.pendingSupplierCancellation ?? 0);

  return (
    <SidebarPulseIndicator
      count={count}
      color="yellow"
      tooltip={t("indicator.tooltip", { count })}
    />
  );
}
